import jQuery from  'jquery';
import moment from "moment-timezone";
import { Market, OddsFormat, BetTypeGroup, BetType, SportGroup, Product, PERIODS_DESC, RUNNING_STATE_EXTRA_TIME, TENNIS_LIVE_SCORE, Mode} from './Foundation';
import { generateTennisScoreDetail, getExtraTimeSoccer } from "./template/OddsPageTemplates/TemplateHelper";
import Utils from './Utils';
import MbOddsDataActions from '../components/MainComponent/AsiaView/MbOddsDataActions';

// ----------------------------------------------------------------------- //
// This extensions only use for doT template to render oddspage.
// ----------------------------------------------------------------------- //
window.Market = Market;
window.OddsFormat = OddsFormat;
window.BetTypeGroup = BetTypeGroup;
window.BetType = BetType;
window.SportGroup = SportGroup;
window.Product = Product;
window.PERIODS_DESC = PERIODS_DESC;
window.getPeriodsName = Utils.getPeriodName;
window.getActualGradingUnit = Utils.getActualGradingUnit;
window.getMoreBetTeamTotal = Utils.getMoreBetTeamTotal;
window.getPeriodMoreBet = Utils.getPeriodMoreBet;
window.fetchParentId = Utils.fetchParentId;
window.getTypeEventTennis = Utils.getTypeEventTennis;
window.getInfoExtraTime = Utils.getInfoExtraTime;
window.getExtraTimeSoccer = getExtraTimeSoccer;
window.RunningStateExtraTime = RUNNING_STATE_EXTRA_TIME;
window.getOrderedPeriodDisplay = Utils.getOrderedPeriodDisplay;
window.TENNIS_LIVE_SCORE = TENNIS_LIVE_SCORE;
window.generateTennisScoreDetail = generateTennisScoreDetail;
window.getRunningPeriods = MbOddsDataActions.getRunningPeriods;
window.hasMultiLineTeamTotal = Utils.hasMultiLineTeamTotal;
window.getBetTypeGroupByMode = (options) => {
    if (options.mode === Mode.PARLAY || options.mode === Mode.PARLAY_MARKET) {
        return BetTypeGroup.HDP_OU;
    } else if(options.isTeaser || options.isTeaserMarket) {
        return BetTypeGroup.TEASERS;
    }
    return options.betTypeGroup;

}
(function($) {
    function DateTZ(dateString) {
        if (arguments.length === 1) {
            if (typeof arguments[0] === 'number') {
                var mil = arguments[0] - (DateTZ.localTimeZone - DateTZ.defaultTZOffset) * 60000;
                return new Date(mil);
            } else {
                return new Date(dateString);
            }
        } else if (arguments.length === 0) {
            return new Date();
        }
        return new Date(arguments[0] || 0, arguments[1] || 0, arguments[2] || 0, arguments[3] || 0, arguments[4] || 0, arguments[5] || 0, arguments[6] || 0);
    }
    DateTZ.localTimeZone = -(new Date().getTimezoneOffset());
    DateTZ.defaultTZOffset = DateTZ.localTimeZone;
    window.DateTZ = DateTZ;

    Array.prototype.init = function(length, startValue) {
        for (var i = 0; i < length; i++) {
            this[i] = startValue === undefined ? i : startValue++;
        }
        return this;
    };

    SportGroup.stringOf = function (value) {
        for (var name in this) {
            if (value === this[name]) {
                return name;
            }
        }
    };

    String.prototype.replaceAll = function (target, replacement) {
        return this.split(target).join(replacement);
    };

    String.prototype.formatSeparators = function () {
        var inD = ".", outD = ".", sep = ",";
        var result = this;    
        result += '';
        var dpos = result.lastIndexOf(inD);
        var nStrEnd = '';
        if (dpos !== -1) {
                nStrEnd = outD + result.substring(dpos + 1, result.length);
                result = result.substring(0, dpos);
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(result)) {
                result = result.replace(rgx, '$1' + sep + '$2');
        }
        return result + nStrEnd;    
    };

    String.prototype.format = function () {
      var a = this;
      for (var k in arguments) {
          a = a.replace(new RegExp("\\{" + k + "\\}", 'g'), arguments[k]);
      }
      return a
    };

/**
     * Truncate number to a decimal point
     * @param digits
     * @example
     * (0.1259).truncate() == 0
     * (0.1259).truncate(2) == 0.12
     * (0.1259).truncate(6) == 0.1259
     */
    Number.prototype.truncate = function(digits, lengthy) {
      var pow = Math.pow(10, digits || 0);
      var result = Math.floor(this * pow) / pow;
      return lengthy ? result.toFixed(digits) : result;
    };

    /**
     * Truncate and Format decimal/thousands separator for number
     * @param digits
     * @example
     * (100000.1259).truncate() == 100,000
     * (100000.1259).truncate(2) == 100,000.12
     * (100000.1259).truncate(6) == 100,000.1259
     * (100000.1).truncate(2, true) == 100,000.10
     */
    Number.prototype.truncateAndFormatSepatators = function(digits, lengthy) {
        return this.truncate(digits, lengthy).formatSeparators();
    };

    Number.prototype.formatSeparators = function () {
        var inD = ".", outD = ".", sep = ",";;
        var result = this;    
        result += '';
        var dpos = result.lastIndexOf(inD);
        var nStrEnd = '';
        if (dpos !== -1) {
                nStrEnd = outD + result.substring(dpos + 1, result.length);
                result = result.substring(0, dpos);
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(result)) {
                result = result.replace(rgx, '$1' + sep + '$2');
        }
        return result + nStrEnd;    
    };

    String.prototype.trimStart = function(tail) {
        var result = this;
        while (result.substring(0, tail.length) == tail)
            result = result.substring(tail.length);
        return result.toString();
    };
    
    Number.prototype.toDollar = function(digits, lengthy) {
        var i,
                result = lengthy ? this.toFixed(digits) : this.toFlex(digits),
                minus = result.startsWith("-");
        if (minus) {
            result = result.trimStart("-");
        }

        digits = digits || 0;

        var buffer = [];

        // get the index or '.', if not found, start from the last didigt
        var last = result.lastIndexOf('.');

        if (last < 0) {
            last = result.length - 1;
        } else {// right now assume 2 digits only, no care is take for the decimals
            last -= 1;
            for (i = result.length - 1; i > last; i--) {
                buffer.push(result.charAt(i));
            }
        }
        var sep = ",";
        for (i = last; i >= 0; i--) {
            var count = last - i;
            if (count > 0 && count % 3 == 0) {
                buffer.push(sep);
            }
            buffer.push(result.charAt(i));
        }
        if (minus) {
            buffer.push("-");
        }
        return buffer.reverse().join('').toString().formatSeparators();
    };

    Number.prototype._toFixed = Number.prototype.toFixed;
    /**
     * Overide to ensure same output in IE and other browser
     */
    Number.prototype.toFixed = function(digits) {
        return Math.round(this, digits)._toFixed(digits);
    };
    
    Array.prototype.removeAll = function(items) {
        var newItems = [];
        for (var i = 0; i < this.length; i++) {
            if ($.inArray(this[i], items) === -1) {
                newItems.push(this[i]);
            }
        }
        return newItems;
    };

    Array.prototype.addAll = function(item) {
        return this.concat(item);
    };
    Math._round = Math.round;
    Math.round = function(number, bits) {
        if (bits < 0)
            return number;
        bits = bits || 0; // default round 0 decimal
        var dir = number > 0 ? 1 : -1;
        var i = Math.pow(10, bits);
        number = Math.abs(number) + 1 / Math.pow(10, bits + 5);
        return Math._round(number * i) / i * dir;
    };

    window.moment = function(dateString) {
        return moment(dateString);
    }

    Element.prototype.hasScrollBars = function() {
      return {"vertical": this.scrollHeight > this.clientHeight, "horizontal": this.scrollWidth > this.clientWidth};
    }

    function countDecimals(number) {
      if(Math.floor(number.valueOf()) === number.valueOf()) return 0;
      return number.toString().split(".")[1].length || 0; 
    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/app/common/Extensions.js